import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { on as t } from "../core/watchUtils.js";
import { aliasOf as i } from "../core/accessorSupport/decorators/aliasOf.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { property as r } from "../core/accessorSupport/decorators/property.js";
import { subclass as o } from "../core/accessorSupport/decorators/subclass.js";
import s from "./Widget.js";
import n from "./Attribution/AttributionViewModel.js";
import { accessibleHandler as p } from "./support/decorators/accessibleHandler.js";
import { messageBundle as a } from "./support/decorators/messageBundle.js";
import "../core/Logger.js";
import { tsx as d } from "./support/jsxFactory.js";
import "./support/widgetUtils.js";
var c = {
  base: "esri-attribution esri-widget",
  poweredBy: "esri-attribution__powered-by",
  sources: "esri-attribution__sources",
  open: "esri-attribution--open",
  sourcesOpen: "esri-attribution__sources--open",
  link: "esri-attribution__link",
  widgetIcon: "esri-icon-description",
  interactive: "esri-interactive"
};

var l = /*#__PURE__*/function (_s) {
  _inherits(l, _s);

  var _super = _createSuper(l);

  function l(e, t) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this, e, t), _this._isOpen = !1, _this._attributionTextOverflowed = !1, _this._prevSourceNodeHeight = 0, _this.iconClass = c.widgetIcon, _this.itemDelimiter = " | ", _this.label = void 0, _this.messages = null, _this.view = null, _this.viewModel = new n();
    return _this;
  }

  _createClass(l, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.own(t(this, "viewModel.items", "change", function () {
        return _this2.scheduleRender();
      }));
    }
  }, {
    key: "_isInteractive",
    get: function get() {
      return this._isOpen || this._attributionTextOverflowed;
    }
  }, {
    key: "attributionText",
    get: function get() {
      return this.viewModel.items.reduce(function (e, t) {
        return -1 === e.indexOf(t.text) && e.push(t.text), e;
      }, []).join(this.itemDelimiter);
    }
  }, {
    key: "render",
    value: function render() {
      var e = _defineProperty({}, c.open, this._isOpen);

      return d("div", {
        bind: this,
        class: this.classes(c.base, e),
        onclick: this._toggleState,
        onkeydown: this._toggleState
      }, this.renderSourcesNode(), this.renderPoweredBy());
    }
  }, {
    key: "renderPoweredBy",
    value: function renderPoweredBy() {
      return d("div", {
        class: c.poweredBy
      }, "Powered by", " ", d("a", {
        class: c.link,
        href: "http://www.esri.com/",
        target: "_blank",
        rel: "noreferrer"
      }, "Esri"));
    }
  }, {
    key: "renderSourcesNode",
    value: function renderSourcesNode() {
      var _s2;

      var e = this._isOpen,
          t = this._isInteractive,
          i = t ? 0 : -1,
          r = this.attributionText,
          o = t ? "button" : void 0,
          s = (_s2 = {}, _defineProperty(_s2, c.sourcesOpen, e), _defineProperty(_s2, c.interactive, t), _s2);
      return d("div", {
        afterCreate: this._afterSourcesNodeCreate,
        afterUpdate: this._afterSourcesNodeUpdate,
        bind: this,
        class: this.classes(c.sources, s),
        innerHTML: r,
        role: o,
        tabIndex: i
      });
    }
  }, {
    key: "_afterSourcesNodeCreate",
    value: function _afterSourcesNodeCreate(e) {
      this._prevSourceNodeHeight = e.clientWidth;
    }
  }, {
    key: "_afterSourcesNodeUpdate",
    value: function _afterSourcesNodeUpdate(e) {
      var t = !1;
      var i = e.clientHeight,
          r = e.clientWidth,
          o = e.scrollWidth,
          s = o >= r,
          n = this._attributionTextOverflowed !== s;

      if (this._attributionTextOverflowed = s, n && (t = !0), this._isOpen) {
        var _e2 = i < this._prevSourceNodeHeight;

        this._prevSourceNodeHeight = i, _e2 && (this._isOpen = !1, t = !0);
      }

      t && this.scheduleRender();
    }
  }, {
    key: "_toggleState",
    value: function _toggleState() {
      this._isInteractive && (this._isOpen = !this._isOpen);
    }
  }]);

  return l;
}(s);

e([r()], l.prototype, "_isOpen", void 0), e([r()], l.prototype, "_isInteractive", null), e([r()], l.prototype, "_attributionTextOverflowed", void 0), e([r()], l.prototype, "_prevSourceNodeHeight", void 0), e([r({
  readOnly: !0,
  dependsOn: ["viewModel.items.length", "itemDelimiter"]
})], l.prototype, "attributionText", null), e([r()], l.prototype, "iconClass", void 0), e([r()], l.prototype, "itemDelimiter", void 0), e([r({
  aliasOf: {
    source: "messages.widgetLabel",
    overridable: !0
  }
})], l.prototype, "label", void 0), e([r(), a("esri/widgets/Attribution/t9n/Attribution")], l.prototype, "messages", void 0), e([i("viewModel.view")], l.prototype, "view", void 0), e([r({
  type: n
})], l.prototype, "viewModel", void 0), e([p()], l.prototype, "_toggleState", null), l = e([o("esri.widgets.Attribution")], l);
var u = l;
export { u as default };